import { IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { action, makeObservable, observable } from 'mobx';

import { GetPublicCertificateCollaboration } from '@/application/collaborations/certificate/get-public-certificate.collaboration';
import { Tracking } from '@/application/utils/tracking';
import { ApplicationModel } from '@/presentation/models/application.model';
import { StudentClassesStore } from '@/presentation/stores/studentClasses.store';

@ViewModel({ singleton: true })
export class CertificatePublicViewModel implements IReactiveModel {
  @observable isLoading = true;
  @observable certificate: any;

  constructor(
    private readonly applicationModel: ApplicationModel,
    private getPublicCertificateCollaboration: GetPublicCertificateCollaboration,
    private readonly studentClassesStore: StudentClassesStore,
  ) {
    makeObservable(this);
  }

  @action
  async onInit() {
    this.isLoading = false;
    Tracking.pageView(this.studentClassesStore.getStudentClassesTrackingInfo());
  }

  @action
  async handleScreenCertificate(certificateGuid: string) {
    this.isLoading = true;
    try {
      const { data } = await this.getPublicCertificateCollaboration.run(certificateGuid);

      this.certificate = {
        topicName: data.course,
        studentName: data.student,
        workload: data.workload,
        completeIn: data.issue_date,
        expirationIn: data.expiration_date,
        certificateSettings: {
          backgroundImageUrl: data.background,
        },
      };
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  }

  get application() {
    return this.applicationModel.application;
  }
}
